import React, { useState } from "react";

const ExpandableImage = () => {
  const [open, setOpen] = useState(false);

  return (
    <div
      style={{
        position: "fixed",
        bottom: "30px",
        left: "30px",
        zIndex: 1000
      }}
    >
      {!open && (
        <div
          onClick={() => setOpen(true)}
          style={{
            width: "55px",
            height: "55px",
            background: "#00B3B3",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff",
            fontSize: "22px",
            cursor: "pointer",
            boxShadow: "0 6px 18px rgba(0,0,0,0.25)"
          }}
        >
          <i className="fas fa-truck"></i>
        </div>
      )}

      {open && (
        <div
          onClick={() => setOpen(false)}
          style={{
            background: "#fff",
            padding: "18px 22px",
            borderRadius: "14px",
            display: "flex",
            alignItems: "center",
            gap: "12px",
            boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
            cursor: "pointer"
          }}
        >
          <div
            style={{
              width: "42px",
              height: "42px",
              background: "#00B3B3",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#fff",
              fontSize: "18px"
            }}
          >
            <i className="fas fa-truck"></i>
          </div>

          <a
            href="https://play.google.com/store/apps/details?id=com.MrTruck"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none" }}
          >
            <button
              style={{
                background: "#00B3B3",
                color: "#fff",
                border: "none",
                padding: "10px 18px",
                borderRadius: "25px",
                fontWeight: "600",
                cursor: "pointer"
              }}
            >
              Book a Truck ↗
            </button>
          </a>
        </div>
      )}
    </div>
  );
};

export default ExpandableImage;